module.exports = __webpack_public_path__ + "static/media/icon-usermgmt.e37de6a5.svg";